import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=3994b5bb&"
import script from "./GatewayDetail.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports